import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { CreateMessageInMyChat, SafeSupportChatMessage, SupportChat, SupportChatMessage } from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class ChatHttpService {
  private readonly http = inject(HttpClient);

  private API_URL = environment.API_URL;
  private FULL_URL = `${this.API_URL}/my-support-chat`;

  public getMyChat(): Observable<{ supportChat: SupportChat; messages: SafeSupportChatMessage[] }> {
    const url = `${this.FULL_URL}`;
    return this.http.get<{ supportChat: SupportChat; messages: SafeSupportChatMessage[] }>(url);
  }

  public addChatMessage(addMessageOpts: CreateMessageInMyChat): Observable<SafeSupportChatMessage> {
    const url = `${this.FULL_URL}/messages/new`;
    return this.http.post<SafeSupportChatMessage>(url, { ...addMessageOpts });
  }

  public downloadAttachmentFromChat(messageId: string, attachmentId: string): Observable<HttpResponse<Blob>> {
    const url = `${this.FULL_URL}/messages/${messageId}/attachment/${attachmentId}`;
    return this.http.get(url, { responseType: 'blob', observe: 'response' });
  }
}
